// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kXzZ","colMin":"styles_colMin__36P6F"};